function o(t, n) {
  if (!t || n === null)
    return;
  const e = 72;
  window.scrollY - e >= n ? t.style.transform = `translate3d(0px, ${(window.scrollY - e - n) / 2}px, 0px)` : t.style.transform = "translate3d(0px, 0px, 0px)";
}
function a(t, n) {
  return o.bind(this, t, n);
}
function s() {
  let t = null, n = null;
  return { mounted: (l) => {
    if (!t) {
      const r = l.getBoundingClientRect().y;
      t = r > 0 ? r : 0;
    }
    n = a(l, t), n(), window.addEventListener("scroll", n);
  }, unmounted: () => {
    window.removeEventListener("scroll", n);
  } };
}
const c = s();
export {
  c as vParallaxScrollAwds
};
